//意向

import UltMeta, { Meta } from "./UltMeta/index";

class PurType extends UltMeta {
    JOINT = new Meta(1, "联合采购");
    DIRECT = new Meta(2, "直采");
}

export const PUR_TYPE = new PurType();

/**
 * 服务费类型
 */
class ServiceCostType extends UltMeta {
    UNIT_PRICE = new Meta(1, "单价收费");
    FIXED_PRICE = new Meta(2, "一口价");
}

export const SERVICE_COST_TYPE = new ServiceCostType();
